import { GetRequest } from "src/shared/api";
import { config } from "src/config/config";

export const getPublicAssetsPerSerialAPI = (options: any) => {
  const url = `${
    config.MARKETPLACE_API.HOST
  }${config.MARKETPLACE_API.APIS_V2.listed_assets_per_serial(options.kid)}`;

  return GetRequest(url, null, {});
};

export const getSaleAssetsByBrandAPI = (options: any) => {
  const url = `${config.MARKETPLACE_API.HOST}${config.MARKETPLACE_API.APIS_V2.brand_sale_assets}`;
  const data: Record<string, any> = {
    offset: Number(options.pageNumber) * Number(options.pageSize),
    account: options.account,
    limit: options.pageSize,
    sort_by: options.sortBy,
  };
  return GetRequest(url, data, {});
};

export const getRentalAssetsByBrandAPI = (options: any) => {
  const url = `${config.MARKETPLACE_API.HOST}${config.MARKETPLACE_API.APIS_V2.brand_rental_assets}`;
  const data: Record<string, any> = {
    offset: Number(options.pageNumber) * Number(options.pageSize),
    account: options.account,
    limit: options.pageSize,
    sort_by: options.sortBy,
  };
  return GetRequest(url, data, {});
};

export const getTradingAssetsAPI = (options: any) => {
  const url = `${config.MARKETPLACE_API.HOST}${config.MARKETPLACE_API.APIS_V2.trading_assets}`;
  const data: Record<string, any> = {
    // offset: Number(options.pageNumber) * Number(options.pageSize),
    trading_asset_token_ids: options.tradingAssetTokenIds,
    account: options.account,
    // limit: options.pageSize,
    // sort_by: options.sortBy,
  };
  return GetRequest(url, data, {});
};

export const getTradableListedAssetsAPI = (options: any) => {
  const url = `${config.MARKETPLACE_API.HOST}${config.MARKETPLACE_API.APIS_V2.tradable_listed_assets}`;
  const data: Record<string, any> = {
    // offset: Number(options.pageNumber) * Number(options.pageSize),
    trading_asset_token_ids: options.tradingAssetTokenIds,
    account: options.account,
    // limit: options.pageSize,
    // sort_by: options.sortBy,
  };
  return GetRequest(url, data, {});
};

export const getGroupsByBrandAPI = (options: any) => {
  const url = `${
    config.MARKETPLACE_API.HOST
  }${config.MARKETPLACE_API.APIS_V2.brand_groups(options.account)}`;
  const data: Record<string, any> = {
    offset: Number(options.pageNumber) * Number(options.pageSize),
    limit: options.pageSize,
    sort_by: options.sortBy,
  };
  return GetRequest(url, data, {});
};

export const getSpecificAssetDetailsAPI = (options: any) => {
  const url = `${
    config.MARKETPLACE_API.HOST
  }${config.MARKETPLACE_API.APIS_V2.asset_by_id(
    options.assetKid
  )}?user_currency=${options.userCurrency}`;
  return GetRequest(url, null, {});
};

export const getTradeListingAssetTokenIdAPI = (options: any) => {
  const url = `${
    config.MARKETPLACE_API.HOST
  }${config.MARKETPLACE_API.APIS_V2.trade_listing_asset_token_id(
    options.assetKid
  )}`;
  return GetRequest(url, null, {});
};

export const getAcquisitionRestrictionAPI = (options: any) => {
  const url = `${config.MARKETPLACE_API.HOST}${config.MARKETPLACE_API.APIS_V2.acquisition_restriction}`;
  const data = {
    assetTokenId: options.assetTokenId,
  };

  return GetRequest(url, data, {});
};
